export const CREATE_NEW_RUN_MODAL_NAME = 'CREATE_NEW_RUN_MODAL';
